<template>
  <el-dialog title="订单信息" :visible.sync="showModal" :close-on-click-modal="false" :destroy-on-close="true" width="620px">
    <div class="static-box">
      <p>{{ orderState(detailData.state) }}</p>
      <p v-if="detailData.reject">失败原因: {{ detailData.reject }}</p>
    </div>
    <div class="article_box">
      <!-- <el-image style="min-width: 150px; height: 120px" :src="detailData.evaluation.cover_img_vertical"
        fit="cover"></el-image>
      <p class="article-name">{{ detailData.evaluation.name }}</p> -->

      <div class="article_picture" v-if="detailData.evaluation">
        <p>产品图片：</p>
        <el-image style="width: 150px; height: 120px" :src="detailData.evaluation.cover_img_vertical" fit="cover"
          :preview-src-list="[detailData.evaluation.cover_img_vertical]"></el-image>
      </div>

      <div class="article_title">
        <p>产品名称：</p>
        <p class="article_name" v-if="detailData.evaluation">
          {{ detailData.evaluation.name }}
        </p>
      </div>

    </div>
    <div class="detail-info">
      <p>订单编号: {{ detailData.order_id }}</p>
      <p>申请时间: {{ detailData.created_at }}</p>
      <p v-if="detailData.delivery_at">
        发货时间: {{ detailData.delivery_at }}
      </p>
      <p v-if="detailData.signing_at">
        {{ detailData.evaluation.type === 1 ? '签收时间:' : '确认参与时间:' }}
        {{ detailData.signing_at }}
      </p>
      <p v-if="detailData.first_submit_at">
        初稿提交时间: {{ detailData.first_submit_at }}
      </p>
      <p v-if="detailData.first_examine_at">
        初稿审核时间: {{ detailData.first_examine_at }}
      </p>
      <p v-if="detailData.final_submit_at">
        终稿提交时间: {{ detailData.final_submit_at }}
      </p>
      <p v-if="detailData.final_examine_at">
        终稿审核时间: {{ detailData.final_examine_at }}
      </p>
      <div v-if="detailData.logistics_log">
        <p v-if="detailData.logistics_log.logistics_name">
          物流公司: {{ detailData.logistics_log.logistics_name }}
        </p>
        <p v-if="detailData.logistics_log.logistics_number">
          物流单号: {{ detailData.logistics_log.logistics_number }}
        </p>
      </div>
      <div v-if="detailData.channel_id || detailData.evaluation.channels" style="display: flex;flex-wrap: wrap;">
        <p>
          推广平台：
        </p>
        <p v-for="item, index in detailData.channel_nameList" :key="index" style="margin-left: 10px;">
          <el-tag>{{ item }}</el-tag>
        </p>
      </div>

      <div class="platform-item" v-if="detailData.to_store_at_datas && detailData.to_store_at_datas.length > 0">

        <div>
          <div class="flex">
            <!-- <el-tag class="platform-name" v-if="detailData.channel_name">{{ detailData.channel_name }}</el-tag> -->
            <div>探店时间：</div>

            <el-form label-position="left" label-width="80px" ref="listForm" :model="listForm"
              v-if="detailData.to_store_at_datas && detailData.to_store_at_datas.length > 0">
              <div class="flex-c" v-for="item, index in listForm.to_store_at_datas" :key="index">

                <el-form-item :prop="'to_store_at_datas.' + index + '.time'" style="margin-bottom: 20px !important;"
                  :rules="[{ required: true, message: '请输入探店时间', trigger: 'blur' }, { validator: validateSelect, trigger: 'blur' }]">
                  <el-date-picker v-model="item.time" type="date" placeholder="选择探店时间" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </el-form-item>

                <div class="icon">
                  <i v-if="listForm.to_store_at_datas.length !== 1" class="el-icon-remove-outline"
                    @click="deletePlat(index)"></i>
                  <i v-if="listForm.to_store_at_datas.length - 1 === index" class="el-icon-circle-plus-outline"
                    @click="addPlat"></i>
                </div>

                <el-button v-if="listForm.to_store_at_datas.length - 1 === index" style="margin-left: 45px;"
                  type="primary" :loading="platSubmitting" @click="submitPlat('listForm')">提交</el-button>
              </div>

            </el-form>

          </div>

        </div>


        <!-- <div class="platform-item" v-for="platform in userProfile.user_channel" :key="platform.id">
          <el-tag class="platform-name">{{ platform.evaluation_channel_info.name }}</el-tag>
          <el-form label-position="left" label-width="80px">
            <el-form-item v-for="item in platform.data" :key="item.id" :label="item.name">
              <el-input style="max-width:412px;" :value="item.content"></el-input>
            </el-form-item>
          </el-form>
        </div> -->
      </div>
    </div>
    <div class="option-box" style="display: flex;align-items: center;justify-content: space-between;">
      <div>
        <el-button @click="trunOff">返回</el-button>
        <template v-if="detailData.state === 0">
          <el-button type="warning" @click="onShowRejectModal">驳回</el-button>
          <el-button type="primary" @click="onApplicationPass">通过</el-button>
        </template>
      </div>

    </div>

    <el-dialog title="驳回" :visible.sync="rejectModal" :close-on-click-modal="false" :destroy-on-close="true"
      append-to-body width="480px">
      <el-form ref="rejectForm" :model="rejectForm" :rules="rejectRules" label-width="82px">
        <el-form-item label="驳回理由" prop="reject">
          <el-input type="textarea" :rows="4" v-model="rejectForm.reject" />
        </el-form-item>
        <div style="margin-left:82px;">
          <el-button @click="rejectModal = false">取消</el-button>
          <el-button type="primary" :loading="rejectSubmitting" @click="onReject('rejectForm')">确认</el-button>
        </div>
      </el-form>
    </el-dialog>
  </el-dialog>
</template>

<script>
import { zhongcao } from "@/api/order";

import { checkPlatform } from "@/utils/common"
export default {
  data() {
    return {

      validateSelect: (rule, value, callback) => {
        if (this.listForm.to_store_at_datas.length > 1) {
          if (this.listForm.to_store_at_datas.filter(item => value == item.time).length > 1) {
            callback(new Error('探店时间重复'))
          } else {
            callback()
          }
        } else {
          callback()
        }

      },
      rejectModal: false,
      rejectRules: {
        reject: [{ required: true, message: "请输入驳回理由", trigger: "blur" }],
      },
      rejectForm: {
        order_id: null,
        reject: "",
      },
      rejectSubmitting: false,
      platSubmitting: false,
      value: '',
      listForm: {
        to_store_at_datas: [],
      },

    }
  },
  props: {
    show: {
      default: false,
      type: Boolean,
    },
    detailData: Object,
  },
  watch: {
    listForm: {
      handler(val) {
        if (val.to_store_at_datas && val.to_store_at_datas.length > 0 && this.$refs['listForm']) {
          this.$nextTick(() => {
            this.$refs['listForm'].validate(() => { })
          })
        }
      },
      deep: true
    }
  },
  created() {

    let channelValue = this.detailData.channel_id != null ? this.detailData.channel_id : this.detailData.evaluation.channels
    this.detailData.channel_nameList = channelValue.split(',').map(item => {
      return checkPlatform(item).name
    })

    this.listForm.to_store_at_datas = this.detailData.to_store_at_datas ? this.detailData.to_store_at_datas.map(item => ({ time: item })) : [{ time: '' }]
  },
  methods: {
    submitPlat(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            let to_store_at_array = this.listForm.to_store_at_datas.map(item => item.time)
            this.platSubmitting = true;
            await zhongcao.updateToStoreAtDatas({ to_store_at_array, order_id: this.detailData.order_id });
            this.$message({
              message: "探店时间已修改!",
              type: "success",
            });
            this.rejectModal = false;
            this.$emit("onUpdate");
            this.trunOff();
          } catch {
            // this.$message.error("出错了!");
          } finally {
            this.platSubmitting = false;
          }
        }
      });
    },
    deletePlat(index) {
      this.$refs['listForm'].clearValidate()
      this.listForm.to_store_at_datas.splice(index, 1)
    },
    addPlat() {
      this.listForm.to_store_at_datas.push({ time: '' })
    },
    trunOff() {
      this.showModal = false;
    },
    orderState(state) {
      switch (state) {
        case 0:
          return "申请中";
        case -1:
          return "申请失败";
        case 1:
          return "申请成功";
        case 2:
          return "已发货";
        case 3:
          return "待提交初稿";
        case 4:
          return "待审核初稿";
        case 5:
          return "审核失败初稿";
        case 6:
          return "待提交终稿";
        case 7:
          return "待审核终稿";
        case 8:
          return "审核失败终稿";
        case 9:
          return "已完成";
        case 10:
          return "订单已关闭";
        case 12:
          return "选择我不去了";
        case 13:
          return "待发放积分";
        default:
          return "订单取消";
      }
    },
    onShowRejectModal() {
      this.rejectForm.order_id = this.detailData.order_id;
      this.rejectForm.reject = "";
      this.rejectModal = true;
    },
    onApplicationPass() {
      this.$confirm("此操作将通过审核, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(async () => {
          try {
            await zhongcao.applicationPass(this.detailData.order_id);
            this.$message({
              type: "success",
              message: "已通过审核!",
            });
            this.$emit("onUpdate");
            this.trunOff();
          } catch {
            this.$message.error("出错了!");
          }
        })
        .catch(() => {
          this.$message("审核取消!");
        });
    },
    onReject(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (valid) {
          try {
            this.rejectSubmitting = true;
            await zhongcao.applicationReject(this.rejectForm);
            this.$message({
              message: "已驳回!",
              type: "success",
            });
            this.rejectModal = false;
            this.$emit("onUpdate");
            this.trunOff();
          } catch {
            this.$message.error("出错了!");
          } finally {
            this.rejectSubmitting = false;
          }
        }
      });
    },
  },
  computed: {
    showModal: {
      get() {
        return this.show;
      },
      set(val) {
        this.$emit("update:show", val);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.static-box {
  margin-top: -14px;
}

.article_box {
  padding-bottom: 20px;

  .article_picture {
    display: flex;
    align-items: flex-start;

    p {
      margin-top: 0 !important;
    }
  }

  .article_title {
    display: flex;
    align-items: center;

    .article_name {
      font-size: 1rem;
      margin: 0;
      margin-left: 10px;
    }
  }
}

.platform-item {
  display: flex;
}

.icon {
  font-size: 24px;
  margin-left: 5px;

  i {
    margin-left: 15px;
  }
}

.flex-c {
  display: flex;
  align-items: center;

}
</style>
<style lang="scss">
.flex {
  display: flex;
  // align-items: center;
  // margin-bottom: 10px;

  .el-form-item {
    margin-bottom: 10px !important;
  }

  .el-form-item__content {
    margin-left: 15px !important;
  }
}
</style>
